import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Dices, X } from "lucide-react";

const OUTCOME = {
  erfolg: { label: "ERFOLG", bg: "bg-hammerl-highlight", text: "text-hammerl-paper", quote: "Eleganter Triumph!" },
  gemischt: { label: "GEMISCHT", bg: "bg-hammerl-mixed", text: "text-hammerl-paper", quote: "Klappt — irgendwie." },
  fehlschlag: { label: "FEHLSCHLAG", bg: "bg-hammerl-fail", text: "text-white", quote: "Galopp-GAU. Voigt schüttelt den Kopf." },
};

export default function DiceRollOverlay({ value, outcome, onClose }) {
  const [display, setDisplay] = useState(0);
  const [done, setDone] = useState(false);

  useEffect(() => {
    let step = 0;
    const totalSteps = 22;
    const interval = setInterval(() => {
      step += 1;
      if (step >= totalSteps) {
        setDisplay(value);
        setDone(true);
        clearInterval(interval);
      } else {
        setDisplay(Math.floor(Math.random() * 101));
      }
    }, 55);
    return () => clearInterval(interval);
  }, [value]);

  useEffect(() => {
    if (!done) return;
    const t = setTimeout(() => onClose(), 1800);
    return () => clearTimeout(t);
  }, [done, onClose]);

  const o = OUTCOME[outcome] || OUTCOME.gemischt;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4"
      data-testid="dice-overlay"
    >
      <motion.div
        initial={{ scale: 0.6, rotate: -8 }}
        animate={{ scale: 1, rotate: 0 }}
        exit={{ scale: 0.8, opacity: 0 }}
        className="bg-hammerl-card border-4 border-hammerl-ink shadow-brutal-lg p-8 sm:p-12 max-w-md w-full relative"
      >
        <button
          onClick={onClose}
          className="absolute top-2 right-2 p-1 hover:bg-hammerl-ink hover:text-white"
          aria-label="Schließen"
          data-testid="dice-close-btn"
        >
          <X className="w-4 h-4" />
        </button>
        <div className="font-mono text-xs uppercase tracking-widest text-hammerl-pencil text-center flex items-center justify-center gap-2">
          <Dices className="w-4 h-4" /> d100 // Galopp-Revision
        </div>
        <motion.div
          animate={done ? { scale: [1, 1.15, 1] } : {}}
          transition={{ duration: 0.4 }}
          className="font-mono font-bold text-center my-6 select-none text-hammerl-ink"
        >
          <div className="text-8xl sm:text-9xl tracking-tighter" data-testid="dice-value">{display}</div>
        </motion.div>
        {done && (
          <motion.div
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center"
          >
            <div className={`inline-block px-6 py-2 border-2 border-hammerl-ink font-bold tracking-widest ${o.bg} ${o.text}`} data-testid="dice-outcome">
              {o.label}
            </div>
            <div className="font-handwriting text-2xl text-hammerl-blue mt-3 -rotate-1">{o.quote}</div>
          </motion.div>
        )}
      </motion.div>
    </motion.div>
  );
}
